import React from 'react'
import SearchableTableACDCNotCollapsed from '../SearchableTableACDCNotCollapsed'

const TableACDCLimitedRelease = () => {
  return (
    <>
      <SearchableTableACDCNotCollapsed
        rowDataName="card_supported_currencies_full_focus_row"
        colDataName="card_supported_currencies_full_focus_column"
        searchKeys={['currencyCode.value', 'currencyName.value']}
        searchable={true}
      />
    </>
  )
}

export default TableACDCLimitedRelease
